<template>
  <!-- Add animated background -->
  <div class="animated-background">
    <div class="floating-elements">
      <span class="element code">{ }</span>
      <span class="element book">📚</span>
      <span class="element graduation">🎓</span>
      <span class="element tech">💻</span>
      <span class="element atom">⚛️</span>
      <span class="element formula">∑</span>
      <span class="element infinity">∞</span>
      <span class="element binary">01</span>
      <span class="element circuit"></span>
      <span class="element grid"></span>
    </div>
  </div>
  <div dir="rtl">
    <!-- First row: Page title -->
    <div class="mb-4">
      <h1>حجز قاعة</h1>
    </div>
    
    <!-- Second row: Add button and search bar -->
    <div class="d-flex mb-4">
      <div style="width: 25%; padding-left: 16px;">
        <v-btn 
          color="primary" 
          @click="showAddNewBooking" 
          block
          height="56px"
          class="mt-n1"
        >
          <v-icon start>mdi-plus</v-icon>
          حجز قاعة
        </v-btn>
      </div>
      <div style="width: 75%;">
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="بحث"
      single-line
      hide-details
          class="rtl-input"
    ></v-text-field>
      </div>
    </div>

    <!-- Summarized Table -->
    <v-data-table
    
      :headers="summaryHeaders"
      :items="bookingsList"
      :search="search"
      class="elevation-3"
      :sort-by="[{key: 'id', order: 'desc'}]"
      :items-per-page="10"
      :page="1"
      :first-page-label="'الصفحة الأولى'"
      :last-page-label="'الصفحة الأخيرة'"
      :next-page-label="'الصفحة التالية'"
      :prev-page-label="'الصفحة السابقة'"
      :rows-per-page-label="'عدد الصفوف'"
      
      :total-items="bookingsList.length"
      :total-pages="Math.ceil(bookingsList.length / 10)"
      :items-per-page-text="'عدد الصفوف'"
      
      
     :footer-props="{
      'items-per-page-options': [10, 20, 50, 100]
     }"
   
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.customer }}</td>
          <td>{{ getRoomName(item.room_id) }}</td>
          <td>{{ formatDate(item.date_from) }}</td>
          <td>{{ formatTime(item.time_from) }} - {{ formatTime(item.time_to) }}</td>
          <td>{{ formatNumber(item.total_price) }} دينار ليبي</td>
          <td>
           <!-- <v-icon small class="mr-2" @click="showDetails(item)">mdi-eye</v-icon> -->
            <v-icon small class="mr-2" @click="editBooking(item)">mdi-pencil</v-icon>
            <v-icon small class="mr-2" @click="confirmDeleteBooking(item.id)" v-if="hasDeletePermission" color="error" title="حذف الحجز">mdi-delete</v-icon>
            <v-icon small class="mr-2" @click="showPayments(item)" title="المدفوعات">
              mdi-cash-multiple
            </v-icon>
            <v-icon small class="mr-2" @click="printBookingReceipt(item)" title="طباعة إيصال الحجز" color="primary">
              mdi-printer
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>

    <!-- Details Dialog -->
    <v-dialog v-model="showDetailsDialog" max-width="600" persistent>
      <v-card class="receipt-dialog">
        <v-card-title class="text-center d-block pa-4 receipt-header">
          <img src="@/assets/soufara.png" alt="Logo" class="receipt-logo mb-2">
          <h2>مركز سفراء العلم للتدريب</h2>
          <p>تفاصيل الحجز</p>
        </v-card-title>
        
        <v-card-text class="pa-4">
          <div class="receipt-content">
            <div class="receipt-row">
              <span class="receipt-label">اسم العميل:</span>
              <span class="receipt-value">{{ selectedBooking.customer }}</span>
            </div>
            <div class="receipt-row">
              <span class="receipt-label">القاعة:</span>
              <span class="receipt-value">{{ getRoomName(selectedBooking.room_id) }}</span>
            </div>
            <div class="receipt-row" v-if="selectedBooking.coffee_breaks">
              <span class="receipt-label">الاستراحة:</span>
              <span class="receipt-value">{{ getBreakName(selectedBooking.coffee_breaks) }}</span>
            </div>
            <div class="receipt-row">
              <span class="receipt-label">التاريخ:</span>
              <span class="receipt-value">{{ formatDate(selectedBooking.date_from) }}</span>
            </div>
            <div class="receipt-row">
              <span class="receipt-label">الوقت:</span>
              <span class="receipt-value">{{ formatTime(selectedBooking.time_from) }} - {{ formatTime(selectedBooking.time_to) }}</span>
            </div>
            <div class="receipt-row">
              <span class="receipt-label">عدد الأشخاص:</span>
              <span class="receipt-value">{{ formatNumber(selectedBooking.number_of_people) }}</span>
            </div>
            <div class="receipt-row">
              <span class="receipt-label">السعر الإجمالي:</span>
              <span class="receipt-value">{{ formatNumber(selectedBooking.total_price) }} دينار ليبي</span>
            </div>
            <div class="receipt-row">
              <span class="receipt-label">الخصم:</span>
              <span class="receipt-value">{{ formatNumber(selectedBooking.discount) }} دينار ليبي</span>
            </div>
            <div class="receipt-row">
              <span class="receipt-label">طريقة الدفع:</span>
              <span class="receipt-value">{{ getPaymentTypeText(selectedBooking.payment_type) }}</span>
            </div>
            <div class="receipt-row">
              <span class="receipt-label">نوع الحجز:</span>
              <span class="receipt-value">{{ getReservationTypeText(selectedBooking.reservation_type) }}</span>
            </div>
            <div class="receipt-row" v-if="selectedBooking.note">
              <span class="receipt-label">ملاحظات:</span>
              <span class="receipt-value">{{ selectedBooking.note }}</span>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="justify-center pa-4">
          <v-select
            v-model="selectedReceiptType"
            :items="receiptTypes"
            label="نوع الإيصال"
            class="rtl-input mx-4"
            style="max-width: 200px"
            required
            dense
          ></v-select>
          <v-btn color="primary" @click="print" class="mx-4">
            <v-icon left>mdi-printer</v-icon>
            طباعة
          </v-btn>
          <v-btn color="grey" @click="closeDetailsDialog">
            إغلاق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Print Receipt Template (hidden) -->
    <div id="printSection" style="display: none;">
      <div class="print-container">
        <!-- HEADER SECTION (30% height) -->
        <div class="receipt-header">
          <div class="logo-container">
            <img src="@/assets/soufara.png" alt="Logo" class="center-logo">
          </div>
          <h2 class="center-title">مركز سفراء العلم للتدريب</h2>
          <div class="receipt-subheader">
            <div class="receipt-date">{{ formatDate(new Date()) }}</div>
            <div class="receipt-type">إيصال دفع</div>
          </div>
        </div>
        
        <!-- DATA SECTION (40% height) -->
        <div class="receipt-data">
          <div class="receipt-row">
            <span class="receipt-label">اسم العميل:</span>
            <span class="receipt-value">{{ selectedBooking.customer }}</span>
          </div>
          <div class="receipt-row">
            <span class="receipt-label">القاعة:</span>
            <span class="receipt-value">{{ getRoomName(selectedBooking.room_id) }}</span>
          </div>
          <div class="receipt-row">
            <span class="receipt-label">المبلغ الإجمالي:</span>
            <span class="receipt-value">{{ formatNumber(selectedBooking.total_price) }} د.ل</span>
          </div>
          <div class="receipt-row">
            <span class="receipt-label">المبلغ المدفوع:</span>
            <span class="receipt-value">{{ formatNumber(receiptData.amount) }} د.ل</span>
          </div>
          <div class="receipt-row">
            <span class="receipt-label">المتبقي قبل الدفع:</span>
            <span class="receipt-value">{{ formatNumber(receiptData.remaining_before) }} د.ل</span>
          </div>
          <div class="receipt-row">
            <span class="receipt-label">المتبقي بعد الدفع:</span>
            <span class="receipt-value">{{ formatNumber(receiptData.remaining_after) }} د.ل</span>
          </div>
          <div class="receipt-row" v-if="receiptData.note">
            <span class="receipt-label">ملاحظات:</span>
            <span class="receipt-value">{{ receiptData.note }}</span>
          </div>
        </div>
        
        <!-- FOOTER SECTION (30% height) -->
        <div class="receipt-footer">
          <div class="signature-section">
            <p class="signature-label">توقيع المستلم</p>
            <div class="signature-line"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Booking Receipt Print Template (hidden) -->
    <div id="bookingPrintSection" style="display: none;">
      <div style="font-family: 'Cairo', sans-serif; direction: rtl; max-width: 600px; margin: 0 auto; padding: 20px; color: #000;">
        
        <!-- Header with Logo -->
        <div style="text-align: center; margin-bottom: 15px; border-bottom: 2px solid #000; padding-bottom: 12px;">
          <img src="@/assets/soufara.png" alt="Logo" style="max-width: 180px; margin-bottom: 8px;">
          <h2 style="font-size: 16px; margin: 0; font-weight: 600;">مركز سفراء العلم للتدريب</h2>
        </div>

        <!-- Receipt Type -->
        <div style="text-align: center; margin-bottom: 15px;">
          <h1 style="font-size: 20px; margin: 0; font-weight: bold;">حجز قاعة</h1>
          <div style="font-size: 12px; margin-top: 3px;">التاريخ: {{ formatDate(bookingReceiptData.booking_date) }}</div>
        </div>

        <!-- Booking Details Table -->
        <table style="width: 100%; border-collapse: collapse; margin: 15px 0; font-size: 13px;">
          <tr style="border-bottom: 1px solid #ddd;">
            <td style="padding: 6px 10px; font-weight: bold; width: 35%;">اسم العميل</td>
            <td style="padding: 6px 10px; text-align: right;">{{ bookingReceiptData.customer_name }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #ddd;">
            <td style="padding: 6px 10px; font-weight: bold;">القاعة</td>
            <td style="padding: 6px 10px; text-align: right;">{{ bookingReceiptData.room_name }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #ddd;">
            <td style="padding: 6px 10px; font-weight: bold;">من تاريخ</td>
            <td style="padding: 6px 10px; text-align: right;">{{ formatDate(bookingReceiptData.start_date) }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #ddd;">
            <td style="padding: 6px 10px; font-weight: bold;">إلى تاريخ</td>
            <td style="padding: 6px 10px; text-align: right;">{{ formatDate(bookingReceiptData.end_date) }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #ddd;">
            <td style="padding: 6px 10px; font-weight: bold;">الوقت</td>
            <td style="padding: 6px 10px; text-align: right;">{{ formatTime(bookingReceiptData.time_from) }} - {{ formatTime(bookingReceiptData.time_to) }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #ddd;">
            <td style="padding: 6px 10px; font-weight: bold;">طريقة الدفع</td>
            <td style="padding: 6px 10px; text-align: right;">{{ bookingReceiptData.payment_type }}</td>
          </tr>
        </table>

        <!-- Financial Details -->
        <div style="margin: 15px 0; padding: 12px; border: 2px solid #000;">
          <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
            <tr>
              <td style="padding: 5px 0; font-weight: bold;">المبلغ الإجمالي</td>
              <td style="padding: 5px 0; text-align: left; font-weight: bold;">{{ formatNumber(bookingReceiptData.total_amount) }} دينار ليبي</td>
            </tr>
            <tr style="border-top: 1px solid #ccc;">
              <td style="padding: 5px 0; font-weight: bold;">المبلغ المدفوع</td>
              <td style="padding: 5px 0; text-align: left;">{{ formatNumber(bookingReceiptData.paid_amount) }} دينار ليبي</td>
            </tr>
            <tr style="border-top: 2px solid #000;">
              <td style="padding: 5px 0; font-weight: bold; font-size: 15px;">المبلغ المتبقي</td>
              <td style="padding: 5px 0; text-align: left; font-weight: bold; font-size: 15px;">{{ formatNumber(bookingReceiptData.remaining_amount) }} دينار ليبي</td>
            </tr>
          </table>
        </div>

        <!-- Additional Info -->
        <div style="font-size: 12px; margin: 12px 0; padding: 10px 0; border-top: 1px solid #ddd;">
          <div style="margin-bottom: 5px;">
            <span style="font-weight: bold;">تم الحجز بواسطة:</span>
            <span style="margin-right: 8px;">{{ bookingReceiptData.booked_by }}</span>
          </div>
          <div>
            <span style="font-weight: bold;">تاريخ الحجز:</span>
            <span style="margin-right: 8px;">{{ formatDate(bookingReceiptData.booking_date) }}</span>
          </div>
        </div>

      </div>
    </div>

    <v-dialog v-model="showAddDialog" max-width="800px" persistent>
      <v-card class="rtl-dialog rtl">
        <!-- Dialog Header -->
        <v-card-title >
          <span class="headline">{{ formTitle }}</span>
          <v-icon 
            class="close-icon" 
            @click="closeDialog"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <!-- Dialog Content -->
        <v-card-text class="dialog-content rtl">
          <v-form class="rtl" ref="form" v-model="valid" @submit.prevent="submit">
            <v-row class="rtl">
              <v-col class="rtl" cols="12">
                <v-checkbox
                  :model-value="!form.daily"
                  @update:model-value="form.daily = !$event"
                  label="حجز بالساعة"
                  @change="handleBookingTypeChange"
                  position="right"
                  class="rtl-input"
                ></v-checkbox>
              </v-col>
              </v-row> <v-row class="rtl">
              <v-col  cols="12" md="6">
                <v-text-field
                  v-model="form.customer"
                  label="اسم العميل"
                  :rules="[v => !!v || 'اسم العميل مطلوب']"
                  class="rtl-input "
                  variant="outlined"
                 
                ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.room_id"
                  :items="availableRooms"
                  item-title="name"
                  item-value="id"
                  
                  label="القاعة"
                  :rules="[v => !!v || 'القاعة مطلوبة']"
                  class="rtl-input"
                  variant="outlined"
                  density="comfortable"
                ></v-select>
              </v-col>
            </v-row>
            <v-row dir="rtl">
        
              
              <v-col cols="12" md="6">
                <VueDatePicker
                  v-model="selectedDates"
                  locale="ar"
                  multi-dates
                  format="yyyy-MM-dd"
                  placeholder="اختر التواريخ"
                  :min-date="new Date()"
                  
                  :disabled="!form.room_id"
                  :disabled-dates="disallowedDates"
                  :enable-time-picker="false"
                  :auto-apply="false"
                  :close-on-auto-apply="false"
                  text-input

                  @update:model-value="handleDateSelection"
                  :text-input-options="{
                    format: datePickerFormat,
                    

                    rangeSeparator: ' إلى '
                  }"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.coffee_breaks"
                  :items="availableBreaks"
                  item-title="name"
                  item-value="id"
                  label="استراحات القهوة"
                  multiple
                  variant="outlined"
                  chips
                  closable-chips
                  :rules="[v => !!v || 'هذا الحقل مطلوب']"
                  required
                  class="rtl-input cairo-font"
                  :menu-props="{ contentClass: 'cairo-font' }"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.time_from"
                  label="من الساعة"
                  type="time"
                  class="rtl-input"
                  :rules="[v => !!v || 'هذا الحقل مطلوب']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                    <v-text-field
                  v-model="form.time_to"
                  label="إلى الساعة"
                  type="time"
                  class="rtl-input"
                  :rules="[v => !!v || 'هذا الحقل مطلوب']"
                  required
                    ></v-text-field>
              </v-col>
              
              <v-col cols="12" md="6">
                    <v-text-field
                  v-model.number="form.number_of_people"
                  label="عدد الأشخاص"
                  variant="outlined"
                  type="number"
                  class="rtl-input"
                  :rules="[v => !!v || 'هذا الحقل مطلوب']"
                  required
                    ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.payment_type"
                  :items="paymentTypes"
                  item-title="text"
                  item-value="value"
                  variant="outlined"
                  label="طريقة الدفع"
                  class="rtl-input"
                  :rules="[v => !!v || 'هذا الحقل مطلوب']"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.reservation_type"
                  :items="reservationTypes"
                  item-title="text"
                  item-value="value"
                  variant="outlined"
                  label="نوع الحجز"
                  class="rtl-input"
                  :rules="[v => !!v || 'هذا الحقل مطلوب']"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.note"
                  label="ملاحظات"
                  variant="outlined"
                  class="rtl-input"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="form.total_price"
                  label="السعر الإجمالي"
                  type="number"
                  variant="outlined"
                  class="rtl-input"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="form.discount"
                  label="الخصم"
                  type="number"
                  variant="outlined"
                  class="rtl-input"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="netAmount"
                  label="صافي المبلغ"
                  readonly
                  prefix="د.ل"
                  variant="outlined"
                  class="rtl-input cairo-font"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <!-- Dialog Actions -->
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            variant="text"
            @click="closeDialog"
            class="action-btn"
          >
            إلغاء
          </v-btn>
          <v-btn
            color="primary"
            variant="text"
            @click="submit"
            class="action-btn"
            :loading="isLoading"
          >
            حفظ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add this after your other dialogs -->
    <v-dialog v-model="paymentsDialog" max-width="900px">
      <v-card class="rtl-dialog">
        <v-card-title class="text-h5">المدفوعات</v-card-title>
        <v-card-text>
          <!-- Booking Summary -->
          <v-row class="mb-4">
            <v-col cols="12" md="3">
              <strong>العميل:</strong> {{ selectedBooking.customer }}
            </v-col>
            <v-col cols="12" md="3">
              <strong>القاعة:</strong> {{ getRoomName(selectedBooking.room_id) }}
            </v-col>
            <v-col cols="12" md="3">
              <strong>المبلغ الإجمالي:</strong> {{ formatNumber(selectedBooking.net_price) }} د.ل
            </v-col>
            <v-col cols="12" md="3">
              <strong>المتبقي:</strong> {{ formatNumber(Number(selectedBooking.remaining)) }} د.ل
            </v-col>
          </v-row>

          <!-- Add Payment Button -->
          <v-row class="mb-4">
            <v-col cols="12" class="text-left">
              <v-btn
                color="primary"
                @click="showAddPayment"
                :disabled="!Number(selectedBooking.remaining)"
              >
                <v-icon start>mdi-plus</v-icon>
                إضافة دفعة
              </v-btn>
            </v-col>
          </v-row>

          <!-- Payments Table -->
          <v-data-table
            :headers="paymentHeaders"
            :items="payments"
            class="elevation-3"
          >
            <template #[`item.created_at`]="{ item }">
              {{ formatDate(item.created_at) }}
            </template>
            <template #[`item.amount`]="{ item }">
              {{ formatNumber(item.amount) }} د.ل
            </template>
            <template #[`item.remaining_before`]="{ item }">
              {{ formatNumber(item.remaining_before) }} د.ل
            </template>
            <template #[`item.remaining_after`]="{ item }">
              {{ formatNumber(item.remaining_after) }} د.ل
            </template>
            <template #[`item.actions`]="{ item: payment }">
              <v-icon
                small
                class="mr-2"
                @click="printReceipt(payment)"
                title="طباعة الإيصال"
              >
                mdi-printer
              </v-icon>
              <v-icon
                small
                @click="confirmDeletePayment(payment)"
                v-if="hasDeletePermission && payment.id"
                color="error"
                title="حذف الدفعة"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="paymentsDialog = false">
            إغلاق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Payment Dialog -->
    <v-dialog v-model="addPaymentDialog" max-width="500px">
      <v-card class="rtl-dialog">
        <v-card-title class="text-h5">إضافة دفعة جديدة</v-card-title>
        <v-card-text>
          <v-form ref="paymentForm">
            <v-text-field
              v-model="newPayment.amount"
              label="المبلغ"
              type="number"
              :rules="[
                v => !!v || 'المبلغ مطلوب',
                v => Number(v) <= Number(selectedBooking.remaining) || 'المبلغ أكبر من المتبقي'
              ]"
              class="rtl-input"
            ></v-text-field>
            <v-textarea
              v-model="newPayment.note"
              label="ملاحظات"
              rows="3"
              class="rtl-input"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" variant="text" @click="addPaymentDialog = false">
            إلغاء
          </v-btn>
          <v-btn color="primary" variant="text" @click="addPayment">
            حفظ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Payment Confirmation Dialog -->
    <v-dialog v-model="showDeletePaymentDialog" max-width="500px">
      <v-card class="rtl-dialog">
        <v-card-title class="text-h5">حذف الدفعة</v-card-title>
        <v-card-text>
          هل أنت متأكد من حذف هذه الدفعة؟
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="showDeletePaymentDialog = false">
            إلغاء
          </v-btn>
          <v-btn color="red-darken-1" variant="text" @click="deletePaymentConfirmed">
            حذف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add this dialog to your component -->
    <v-dialog v-model="showDeleteBookingDialog" max-width="500px">
      <v-card class="rtl-dialog">
        <v-card-title class="text-h5">حذف الحجز</v-card-title>
        <v-card-text>
          هل أنت متأكد من حذف هذا الحجز؟ هذا الإجراء لا يمكن التراجع عنه.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="text" @click="showDeleteBookingDialog = false">
            إلغاء
          </v-btn>
          <v-btn color="red-darken-1" variant="text" @click="deleteBookingConfirmed">
            حذف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import Swal from 'sweetalert2';
//import { VDateInput } from 'vuetify/labs/VDateInput'
import paymentService from '../services/paymentService';
//import bookingService from '../services/bookingService';
//import { useDate } from 'vuetify'
//import { ref } from 'vue'

 //const date = ref(new Date('2018-03-02'))
  //const adapter = useDate()
export default {
  name: 'BookRoomComponent',
 
  components: {
    //VDateInput,
  },
  data() {
    return {
      valid: false,
      showAddDialog: false,
      dialogTitle: '',
      dayFromMenu: false,
      dayToMenu: false,
      hourFromMenu: false,
      hourToMenu: false,
      search: '',
      isLoading: false,
      editedIndex: -1,
      editedItem: {},
      form: {
        customer: '',
        room_id: null,
        coffee_breaks: [],
        dates: [],
        time_from: '',
        time_to: '',
        total_price: 0,
        discount: 0,
        number_of_people: 1,
        payment_type: 'cash',
        reservation_type: 'final',
        daily: true,
        note: ''
      },
      defaultForm: {
        customer: '',
        room_id: null,
        coffee_breaks: [],
        dates: [],
        time_from: '',
        time_to: '',
        total_price: 0,
        discount: 0,
        number_of_people: 1,
        payment_type: 'cash',
        reservation_type: 'final',
        daily: true,
        note: ''
      },
      paymentTypes: [
        { text: 'كاش', value: 'cash' },
        { text: 'شيك', value: 'card' },
        { text: 'بطاقة ائتمان', value: 'credit_card' }
      ],
      reservationTypes: [
        { text: 'نهائي', value: 'final' },
        { text: 'مبدئي', value: 'temporary' }
      ],
      headers: [
        { title: 'اسم العميل', key: 'customer', align: 'center' },
        { title: 'القاعة', key: 'room_id', align: 'center' },
        { title: 'الاستراحة', key: 'coffee_breaks', align: 'center' },
        { title: 'من تاريخ', key: 'dates', align: 'center' },
        { title: 'الوقت', key: 'time', align: 'center' },
        { title: 'السعر الإجمالي', key: 'total_price', align: 'center' },
        { title: 'الخصم', key: 'discount', align: 'center' },
        { title: 'عدد الأشخاص', key: 'number_of_people', align: 'center' },
        { title: 'طريقة الدفع', key: 'payment_type', align: 'center' },
        { title: 'نوع الحجز', key: 'reservation_type', align: 'center' },
        { title: 'ملاحظات', key: 'note', align: 'center' },
        { title: 'الإجراءات', key: 'actions', align: 'center', sortable: false }
      ],
      showDetailsDialog: false,
      selectedBooking: {
        customer: '',
        room_id: null,
        coffee_breaks: [],
        dates: [],
        time_from: '',
        time_to: '',
        total_price: 0,
        discount: 0,
        net_price: 0,
        remaining: 0
      },
      summaryHeaders: [
        { title: 'اسم العميل', key: 'customer', align: 'center' },
        { title: 'القاعة', key: 'room_id', align: 'center' },
        { title: 'التاريخ', key: 'dates', align: 'center' },
        { title: 'الوقت', key: 'time', align: 'center' },
        { title: 'المبلغ', key: 'total_price', align: 'center' },
        { title: 'الإجراءات', key: 'actions', align: 'center', sortable: false }
      ],
      selectedReceiptType: 'قبض',
      receiptTypes: [
        { title: 'إيصال قبض', value: 'قبض' },
        { title: 'إيصال صرف', value: 'صرف' }
      ],
      selectedDates: null,
      paymentsDialog: false,
      paymentHeaders: [
        { title: 'التاريخ', key: 'created_at', width: '20%' },
        { title: 'المبلغ', key: 'amount', width: '20%' },
        { title: 'المتبقي قبل', key: 'remaining_before', width: '20%' },
        { title: 'المتبقي بعد', key: 'remaining_after', width: '20%' },
        { title: 'ملاحظات', key: 'note' },
        { title: 'الإجراءات', key: 'actions', sortable: false }
      ],
      payments: [],
      disallowedDates: [],
      addPaymentDialog: false,
      newPayment: {
        amount: '',
        paymentable_id: null,
        note: '',
       // Specify that this is a room booking payment
      },
      datePickerFormat: 'yyyy-MM-dd',
      showDeletePaymentDialog: false,
      paymentToDelete: null,
      receiptData: {
        id: null,
        amount: 0,
        created_at: '',
        remaining_before: 0,
        remaining_after: 0,
        note: ''
      },
      amountInWords: '',
      showDeleteBookingDialog: false,
      bookingToDelete: null,
      bookingReceiptData: {
        customer_name: '',
        room_name: '',
        start_date: '',
        end_date: '',
        time_from: '',
        time_to: '',
        payment_type: '',
        total_amount: 0,
        paid_amount: 0,
        remaining_amount: 0,
        booked_by: '',
        booking_date: ''
      }
    }
  },
  computed: {
    ...mapState([
      'allBookings',
      'allBreaks',
    ]),
    ...mapState({
      roomsData: state => state.room.rooms,
      roomsLoading: state => state.room.loading
    }),
    ...mapGetters([
      'allBookings',
      'allBreaks',
    ]),
    ...mapGetters({
      allRooms: 'allRooms'
    }),
    ...mapGetters('auth', ['hasPermission']),
    formTitle() {
      return this.editedIndex === -1 ? 'إضافة حجز جديد' : 'تعديل الحجز';
    },
    bookingsList() {
      return this.allBookings || [];
    },
    availableRooms() {
      const rooms = Array.isArray(this.roomsData) ? this.roomsData : [];
      console.log('Available rooms computed with:', rooms);
      return rooms.filter(room => room.active).map(room => ({
        id: room.id,
        name: room.name,
        price_per_day: room.price_per_day,
        price_per_hour: room.price_per_hour
      }));
    },
    availableBreaks() {
      return Array.isArray(this.allBreaks) ? this.allBreaks : [];
    },
    receiptDetails() {
      return {
        'اسم العميل': this.selectedBooking.customer,
        'القاعة': this.getRoomName(this.selectedBooking.room_id),
        'الاستراحة': this.getBreakName(this.selectedBooking.coffee_breaks || []),
        'التاريخ': this.formatDateArray(this.selectedBooking.dates),
        'الوقت': `${this.formatTime(this.selectedBooking.time_from)} - ${this.formatTime(this.selectedBooking.time_to)}`,
        'عدد الأشخاص': this.formatNumber(this.selectedBooking.number_of_people),
        'المبلغ': `${this.formatNumber(this.selectedBooking.total_price)} د.ل`,
        'الخصم': `${this.formatNumber(this.selectedBooking.discount)} د.ل`,
        'صافي المبلغ': `${this.formatNumber(this.selectedBooking.net_price)} د.ل`
      };
    },
    netAmount() {
      const total = parseFloat(this.form.total_price) || 0;
      const discount = parseFloat(this.form.discount) || 0;
      return (total - discount).toFixed(2);
    },
    disabledDates() {
      return this.disallowedDates || [];
    },
    hasDeletePermission() {
      // Check for the correct permission name or admin role
      const user = this.$store.state.auth.user;
      const isAdmin = user && (user.role === 'admin' || user.role === 'super_admin');
      
      return this.hasPermission('admin.room-bookings.destroy') || isAdmin;
    },
  },
  methods: {
    ...mapActions([
      'fetchBookings',
      'addBooking',
      'updateBooking',
      'deleteBooking',
      'fetchRooms',
      'fetchBreaks',
      'showAlert',
      'fetchDisabledDates',
    ]),
    openBookingDialog() {
      this.dialogTitle = 'حجز قاعة جديد'
      this.showAddDialog = true
      this.form = Object.assign({}, this.defaultForm)
      this.editedIndex = -1
    },
    closeDialog() {
      this.showAddDialog = false
      this.editedItem = {}
      this.editedIndex = -1
      this.dialogTitle = ''
      this.selectedDates = null
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.editedItem = JSON.parse(JSON.stringify(this.form))
        this.save()
      }
    },
    editBooking(item) {
      console.log('Editing booking:', item);
      
      // Create a deep copy of the item to avoid modifying the original
      this.form = { ...item };
      
      // Set the editedItem and editedIndex properly
      this.editedItem = { ...item };
      this.editedIndex = this.bookingsList.findIndex(booking => booking.id === item.id);
      
      // Handle dates properly
      if (item.dates) {
        this.selectedDates = [...item.dates];
      } else if (item.date_from) {
        this.selectedDates = [item.date_from];
        
        if (item.date_to && item.date_to !== item.date_from) {
          const start = new Date(item.date_from);
          const end = new Date(item.date_to);
          const dateArray = [];
          
          let currentDate = new Date(start);
          while (currentDate <= end) {
            dateArray.push(new Date(currentDate).toISOString().split('T')[0]);
            currentDate.setDate(currentDate.getDate() + 1);
          }
          
          this.selectedDates = dateArray;
        }
      } else {
        this.selectedDates = [];
      }
      
      // Handle coffee breaks - check for breaks array first
      if (item.breaks && Array.isArray(item.breaks) && item.breaks.length > 0) {
        // Extract coffee_break_id values from the breaks array
        this.form.coffee_breaks = item.breaks.map(breakItem => breakItem.coffee_break_id);
        console.log('Coffee breaks extracted from breaks array:', this.form.coffee_breaks);
      } else {
        // Fall back to the original coffee_breaks handling
        if (typeof item.coffee_breaks === 'string') {
          try {
            this.form.coffee_breaks = JSON.parse(item.coffee_breaks);
          } catch (e) {
            console.error('Error parsing coffee breaks:', e);
            this.form.coffee_breaks = [];
          }
        } else if (Array.isArray(item.coffee_breaks)) {
          this.form.coffee_breaks = [...item.coffee_breaks];
        } else {
          this.form.coffee_breaks = [];
        }
      }
      
      // Set daily based on reservation type or time
      this.form.daily = item.reservation_type !== 'hourly';
      
      // Show the dialog
      this.showAddDialog = true;
    },
    formatDate(date) {
      if (!date) return '';
      if (date instanceof Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      const d = new Date(date);
      if (isNaN(d.getTime())) {
        console.warn('Invalid date:', date);
        return '';
      }
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatTime(time) {
      if (!time) return '';
      return time.replace(/[٠-٩]/g, d => d.charCodeAt(0) - '٠'.charCodeAt(0));
    },
    getRoomName(roomId) {
      const rooms = Array.isArray(this.roomsData) ? this.roomsData : [];
      const room = rooms.find(r => r.id === roomId);
      return room ? room.name : '';
    },
    getBreakName(breakNames) {
      if (!Array.isArray(breakNames)) return '';
      const breaks = this.availableBreaks.filter(b => breakNames.includes(b.id));
      return breaks.map(b => b.name).join(', ');
    },
    async save() {
      try {
        if (!this.validateForm()) return;

        const requestBody = {
          ...this.form,
          dates: [...this.form.dates],
          coffee_breaks: Array.isArray(this.form.coffee_breaks) ? this.form.coffee_breaks : [],
          daily: this.form.daily,
          time_from: this.form.time_from,
          time_to: this.form.time_to
        };

        console.log('Sending request with body:', requestBody);
        
        let savedBooking;
        if (this.editedIndex > -1 && this.editedItem && this.editedItem.id) {
          console.log('Updating booking with ID:', this.editedItem.id);
          savedBooking = await this.updateBooking({
            id: this.editedItem.id,
            ...requestBody
          });
        } else {
          console.log('Adding new booking');
          savedBooking = await this.addBooking(requestBody);
        }
        
        await this.refreshTable();
        this.closeDialog();
        
        // Open payment dialog for the newly created/updated booking
        if (savedBooking && savedBooking.data) {
          this.selectedBooking = savedBooking.data;
          await this.refreshPayments();
          this.paymentsDialog = true;
        }
      } catch (error) {
        console.error('Error saving booking:', error);
        this.$store.dispatch('showAlert', {
          message: 'حدث خطأ أثناء حفظ الحجز',
          type: 'error'
        });
      }
    },
    handleSearch: debounce(async function() {
      try {
        this.isLoading = true;
        if (!this.search || !this.search.trim()) {
          await this.fetchBookings();
        } else {
          await this.fetchBookings({ customer: this.search.trim() });
        }
      } catch (error) {
        console.error('Search error:', error);
      } finally {
        this.isLoading = false;
      }
    }, 300),
    async refreshTable() {
      try {
        this.isLoading = true;
        if (this.search && this.search.trim()) {
          await this.fetchBookings({ customer: this.search.trim() });
        } else {
          await this.fetchBookings();
        }
      } catch (error) {
        console.error('خطأ في تحديث الجدول:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async initialize() {
      try {
        await Promise.all([
          this.fetchRooms(),
          this.fetchBreaks(),
          this.refreshTable(),
          this.handleBookingTypeChange()
        ]);
      } catch (error) {
        console.error('Error initializing:', error);
      }
    },
    handleBookingTypeChange() {
      if (this.form.daily) {
        this.form.time_from = '08:00';
        this.form.time_to = '16:00';
      } else {
        this.form.time_from = '16:00';
        this.form.time_to = '20:00';
      }
      
      if (this.form.room_id) {
        this.handleFetchAvailableDates();
      }
      
      this.calculateTotalPrice();
    },
    calculateTotalPrice() {
      try {
        if (!this.form.room_id || !this.selectedDates || !this.selectedDates.length) {
          this.form.total_price = 0;
          return;
        }

        const numberOfDays = this.selectedDates.length;
        
        const selectedRoom = this.availableRooms.find(r => r.id === this.form.room_id);
        let roomPrice = 0;
        
        if (this.form.daily) {
          roomPrice = selectedRoom?.price_per_day || 0;
        } else {
          const hours = this.form.time_to.split(':')[0] - this.form.time_from.split(':')[0];
          roomPrice = (selectedRoom?.price_per_hour || 0) * hours;
        }
        
        let coffeeBreaksTotal = 0;
        if (Array.isArray(this.form.coffee_breaks) && this.form.coffee_breaks.length > 0) {
          const selectedBreaks = this.availableBreaks.filter(b => 
            this.form.coffee_breaks.includes(b.id)
          );
          
          coffeeBreaksTotal = selectedBreaks.reduce((total, breakItem) => 
            total + (breakItem.price || 0), 0
          );
        }
        
        const basePrice = roomPrice * numberOfDays;
        const withPeople = basePrice + ((coffeeBreaksTotal * (this.form.number_of_people || 1))* numberOfDays);
        const totalPrice = withPeople ;
        
        this.form.total_price = totalPrice;
        
        console.log('Price calculation:', {
          roomPrice,
          isDaily: this.form.daily,
          coffeeBreaksTotal,
          basePrice,
          withPeople,
          numberOfDays,
          totalPrice
        });
        
      } catch (error) {
        console.error('Error calculating total price:', error);
        this.form.total_price = 0;
      }
    },
    validateTimeRange() {
      if (!this.form.time_from || !this.form.time_to) return true;
      
      const timeFrom = this.form.time_from.split(':');
      const timeTo = this.form.time_to.split(':');
      const startHour = parseInt(timeFrom[0]) + (parseInt(timeFrom[1]) || 0) / 60;
      const endHour = parseInt(timeTo[0]) + (parseInt(timeTo[1]) || 0) / 60;
      
      return endHour > startHour;
    },
    validateDateRange() {
      if (!this.form.dates || !this.form.dates.length) return true;
      
      const dateFrom = new Date(this.form.dates[0]);
      const dateTo = new Date(this.form.dates[this.form.dates.length - 1]);
      
      return dateTo >= dateFrom;
    },
    getPaymentTypeText(value) {
      const type = this.paymentTypes.find(t => t.value === value);
      return type ? type.text : value;
    },
    getReservationTypeText(value) {
      const type = this.reservationTypes.find(t => t.value === value);
      return type ? type.text : value;
    },
    async deleteBooking(id) {
      try {
        const result = await Swal.fire({
          title: 'هل أنت متأكد؟',
          text: 'لن تتمكن من التراجع عن هذا!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'نعم، احذفه!',
          cancelButtonText: 'إلغاء',
          position: 'center',
        });

        if (result.isConfirmed) {
          await this.$store.dispatch('deleteBooking', id);
          await this.refreshTable();
          
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'تم الحذف!',
            text: 'تم حذف الحجز بنجاح',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        console.error('Error deleting booking:', error);
        
        await Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'خطأ!',
          text: 'حدث خطأ أثناء الحذف',
          confirmButtonText: 'حسناً',
          confirmButtonColor: '#F44336',
        });
      }
    },
    showDetails(booking) {
      this.selectedBooking = { ...booking };
      this.showDetailsDialog = true;
    },
    closeDetailsDialog() {
      this.showDetailsDialog = false;
      this.selectedBooking = {};
    },
    print() {
      const printContent = `
        <!DOCTYPE html>
        <html dir="rtl">
          <head>
            <title>إيصال</title>
            <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&display=swap" rel="stylesheet">
            <style>
              @page {
                size: A4;
                margin: 2cm;
              }
              body {
                font-family: 'Cairo', sans-serif;
                direction: rtl;
                padding: 50px;
                margin: 50px;
              }
              .print-content {
                max-width: 800px;
                margin: 0 auto;
                padding: 20px;
              }
              .receipt-header {
                text-align: center;
                margin-bottom: 30px;
                margin-top: 50px;
              }
              .receipt-logo {
                max-width: 350px;
                margin-bottom: 15px;
                margin-top: 50px;
              }
              .date-type-row {
                display: flex;
                justify-content: space-between;
                padding: 10px 0;
                margin: 10px 0;
                border-bottom: 1px solid #333;
              }
              .receipt-content {
                margin: 20px 0;
                width: 100%;
                max-width: 600px;
                margin-left: auto;
                margin-right: auto;
              }
              .receipt-row {
                display: flex;
                justify-content: flex-end;
                padding: 8px 0;
                direction: rtl;
                justify-content: right;
                gap: 20px;
              }
              .receipt-label {
                font-weight: bold;
                order: 1;
                min-width: 100px;
                text-align: left;
              }
              .receipt-value {
                text-align: right;
                min-width: 200px;
                order: 2;
              }
              .amount-in-words {
                text-align: right;
                margin: 30px 0;
                padding: 15px 0;
                border-bottom: 1px solid #333;
              }
              .signature-row {
                display: flex;
                justify-content: space-between;
                margin-top: 50px;
              }
              .signature-line {
                border-top: 1px dotted #333;
                width: 150px;
                display: inline-block;
                margin-top: 5px;
              }
            </style>
          </head>
          <body>
            <div class="print-content">
              <div class="receipt-header">
                <img src="${require('@/assets/soufara.png')}" alt="Logo" class="receipt-logo">
               
              </div>

              <div class="date-type-row">
                <span>التاريخ: ${this.formatDate(new Date())}</span>
                <span>${this.receiptTypes.find(t => t.value === this.selectedReceiptType)?.title || ''}</span>
              </div>

              <div dir="rtl" class="receipt-content">
                <div class="receipt-row">
                   <span class="receipt-label">إسم العميل :</span>
                  <span class="receipt-value">${this.selectedBooking.customer}</span>
                 
                </div>
                <div class="receipt-row">
                     <span class="receipt-label">القاعة : </span>
                  <span class="receipt-value">${this.getRoomName(this.selectedBooking.room_id)}</span>
               
                </div>
                <div class="receipt-row">
                   <span class="receipt-label">التاريخ : </span>
                  <span class="receipt-value">${this.formatDate(this.selectedBooking.dates.join(', '))}</span>
                 
                </div>
                <div class="receipt-row">
                  <span class="receipt-label">الوقت : </span>
                  <span class="receipt-value">${this.formatTime(this.selectedBooking.time_from)} - ${this.formatTime(this.selectedBooking.time_to)}</span>
                  
                </div>
                <div class="receipt-row">
                  <span class="receipt-label">إجمالي التكلفة : </span>
                  <span class="receipt-value">${this.formatNumber(this.selectedBooking.total_price)} دينار ليبي</span>
                  
                </div>
              </div>

              <div class="amount-in-words">
                <div>مبلغ وقدره: ــــــــــــــــــــــــــــــــــــــــــــــــــــــــ دينار ليبي</div>
              </div>

              <div class="signature-row">
                <div>
                  <div>المستلم: ________________</div>
                  <div style="margin-top: 10px;">التوقيع: <span class="signature-line">&nbsp;</span></div>
                </div>
                <div>
                  <div>الاعتماد: ________________</div>
                  <div style="margin-top: 10px;">التوقيع: <span class="signature-line">&nbsp;</span></div>
                </div>
              </div>
            </div>
          </body>
        </html>
      `;

      const printWindow = window.open('', '_blank');
      printWindow.document.write(printContent);
      printWindow.document.close();

      printWindow.onload = function() {
        printWindow.focus();
        printWindow.print();
        printWindow.onafterprint = function() {
          printWindow.close();
        };
      };
    },
    formatNumber(number) {
      if (number === null || number === undefined) return '';
      return number.toString();
    },
    updateTotalPrice() {
      this.calculateTotalPrice();
    },
    async showPayments(booking) {
      try {
        this.selectedBooking = {
          id: booking.id,
          customer: booking.customer,
          room_name: booking.room?.name || '',
          net_price: booking.net_price || (booking.total_price - (booking.discount || 0)),
          remaining: booking.remaining
        };

        this.newPayment = {
          room_booking_id: booking.id,
          amount: 0,
          note: '',
       // Specify that this is a room booking payment
        };

        await this.refreshPayments();
        this.paymentsDialog = true;
      } catch (error) {
        console.error('Error showing payments:', error);
      }
    },
    showAddPayment() {
      this.newPayment = {
        amount: '',
        room_booking_id: this.selectedBooking.id,
        
        note: ''
      };
      this.addPaymentDialog = true;
    },
    async addPayment() {
      try {
        if (!this.$refs.paymentForm.validate()) {
          return;
        }
        
        await paymentService.createPayment({
          ...this.newPayment,
          amount: parseFloat(this.newPayment.amount)
        });

        this.addPaymentDialog = false;
        await this.refreshPayments();
        await this.fetchBookings(); // Refresh bookings to update remaining amount
      } catch (error) {
        console.error('Error saving payment:', error);
      }
    },
    async confirmDeletePayment(payment) {
      this.paymentToDelete = payment;
      this.showDeletePaymentDialog = true;
    },
    async deletePaymentConfirmed() {
      try {
        if (!this.paymentToDelete || !this.paymentToDelete.id) {
          console.error('No payment selected for deletion');
          return;
        }
        
        await paymentService.deletePayment(this.paymentToDelete.id);
        
        // Wait for both operations to complete
        await Promise.all([
          this.refreshPayments(),
          this.fetchBookings()
        ]);
        
        this.showDeletePaymentDialog = false;
        this.paymentToDelete = null;
      } catch (error) {
        console.error('Error deleting payment:', error);
      }
    },
    async refreshPayments() {
      try {
        const response = await paymentService.getPayments({
          paymentable_id: this.selectedBooking.id,
          type: 'room'
        });

        // Handle the response based on its structure
        let paymentsData = [];
        
        if (response.data && Array.isArray(response.data)) {
          paymentsData = response.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          paymentsData = response.data.data;
        }
        
        // Use the payments data directly without additional formatting
        this.payments = paymentsData;
      } catch (error) {
        console.error('Error fetching payments:', error);
        this.payments = [];
      }
    },
    async printReceipt(payment) {
      try {
        // Store the room name and total price before printing
        const roomName = this.getRoomName(this.selectedBooking.room_id);
        const totalPrice = this.selectedBooking.total_price;
        
        console.log('Printing receipt with room:', roomName, 'and total:', totalPrice);
        
        this.receiptData = {
          id: payment.id,
          amount: payment.amount,
          created_at: payment.created_at,
          remaining_before: payment.remaining_before,
          remaining_after: payment.remaining_after,
          note: payment.note || '',
          roomName: roomName,
          totalPrice: totalPrice
        };
        
        // Wait for the next DOM update cycle
        await this.$nextTick();
        
        // Print the receipt
        const printContent = document.getElementById('printSection');
        const originalContents = document.body.innerHTML;
        
        document.body.innerHTML = printContent.innerHTML;
        document.body.style.direction = 'rtl';
        document.body.style.fontFamily = "'Cairo', sans-serif";
        
        window.print();
        document.body.innerHTML = originalContents;
        
        // Reload the Vue instance
        location.reload();
      } catch (error) {
        console.error('Error printing receipt:', error);
      }
    },
    getAmountInWords(amount) {
      return this.convertNumberToArabicWords(amount);
    },
    convertNumberToArabicWords() {
      // ... existing method ...
    },
    async handleRoomChange() {
      if (this.form.room_id) {
        await this.handleFetchAvailableDates();
      } else {
        this.disallowedDates = [];
      }
    },
    async handleFetchAvailableDates() {
      try {
        if (!this.form.room_id) return;
        
        this.loadingDates = true;
        const bookingType = this.form.daily ? 'daily' : 'hourly';
        
        const response = await this.$store.dispatch('fetchDisabledDates', {
          roomId: this.form.room_id,
          bookingType: bookingType
        });
        
        this.loadingDates = false;
        
        if (response && response.success && response.data) {
          console.log('Disabled dates response:', response.data);
          
          this.disallowedDates = response.data.map(booking => {
            return booking.date;
          });
          
          console.log('Disallowed dates set to:', this.disallowedDates);
        }
      } catch (error) {
        console.error('Error fetching disabled dates:', error);
        this.loadingDates = false;
        this.disallowedDates = [];
      }
    },
    allowedDates(dateString) {
      try {
        console.log('Checking date:', dateString);
        console.log('Disallowed dates:', this.disallowedDates);
        
        const checkDate = new Date(dateString);
        return !this.disallowedDates.some(disabledDate => 
          checkDate.getTime() === disabledDate.getTime()
        );
      } catch (error) {
        console.error('Error in allowedDates:', error);
        return true;
      }
    },
    handleDateSelection(dates) {
      if (!Array.isArray(dates)) {
        console.warn('Selected dates is not an array:', dates);
        this.form.dates = [];
        this.selectedDates = [];
        return;
      }

      // Store selected dates for UI
      this.selectedDates = [...dates];
      console.log('Selected dates:', this.selectedDates);
      
      this.form.dates = [];
      for (const date of dates) {
        // Convert to string and take first 10 characters (YYYY-MM-DD)
        const dateString = new Date(date).toISOString();
        console.log('Date string:', dateString);
        const formatted = dateString.substring(0, 10);
        console.log('Formatted date 222:', formatted);
        this.form.dates.push(formatted);
      }

      console.log('Formatted dates for API:', this.form.dates);
      this.calculateTotalPrice();
    },
    validateForm() {
      if (!this.form.dates || !this.form.dates.length) {
        this.$store.dispatch('showAlert', {
          message: 'يرجى اختيار التواريخ',
          type: 'error'
        });
        return false;
      }
      this.handleDateSelection(this.form.dates);
      
      
      return true;
    },
    resetForm() {
      this.editedIndex = -1;
      this.editedItem = null;
      this.form = {
        customer: '',
        room_id: null,
        dates: [],
        time_from: '08:00',
        time_to: '16:00',
        number_of_people: 1,
        coffee_breaks: [],
        daily: true,
        discount: 0,
        note: ''
      };
      this.selectedDates = [];
    },
    formatDateArray(dates) {
      if (!dates || !Array.isArray(dates)) return '';
      return dates.map(date => this.formatDate(date)).join(', ');
    },
    async confirmDeleteBooking(id) {
      this.bookingToDelete = id;
      this.showDeleteBookingDialog = true;
    },
    async deleteBookingConfirmed() {
      try {
        if (!this.bookingToDelete) {
          console.error('No booking selected for deletion');
          return;
        }
        
        await this.deleteBooking(this.bookingToDelete);
        
        this.showDeleteBookingDialog = false;
        this.bookingToDelete = null;
        
        // Show success message
        this.$store.dispatch('showAlert', {
          message: 'تم حذف الحجز بنجاح',
          type: 'success'
        });
      } catch (error) {
        console.error('Error deleting booking:', error);
        this.$store.dispatch('showAlert', {
          message: 'حدث خطأ أثناء حذف الحجز',
          type: 'error'
        });
      }
    },
    showAddNewBooking() {
      this.resetForm();
      this.showAddDialog = true;
    },
    async printBookingReceipt(booking) {
      try {
        // Calculate paid amount
        const netPrice = booking.net_price || (booking.total_price - (booking.discount || 0));
        const paidAmount = netPrice - (booking.remaining || 0);
        
        // Get room name
        const roomName = this.getRoomName(booking.room_id);
        
        // Get start and end dates
        let startDate = booking.date_from;
        let endDate = booking.date_to || booking.date_from;
        
        // If dates array exists, use first and last date
        if (booking.dates && Array.isArray(booking.dates) && booking.dates.length > 0) {
          startDate = booking.dates[0];
          endDate = booking.dates[booking.dates.length - 1];
        }
        
        // Get booked by (username from auth or created_by field)
        const user = this.$store.state.auth.user;
        const bookedBy = booking.created_by_name || user?.name || 'غير معروف';
        
        // Get payment type text
        const paymentTypeText = this.getPaymentTypeText(booking.payment_type);
        
        // Prepare receipt data
        this.bookingReceiptData = {
          customer_name: booking.customer,
          room_name: roomName,
          start_date: startDate,
          end_date: endDate,
          time_from: booking.time_from,
          time_to: booking.time_to,
          payment_type: paymentTypeText,
          total_amount: booking.total_price,
          paid_amount: paidAmount,
          remaining_amount: booking.remaining || 0,
          booked_by: bookedBy,
          booking_date: booking.created_at || new Date().toISOString()
        };
        
        // Wait for next tick to ensure DOM is updated
        await this.$nextTick();
        
        // Create print window
        const printContent = document.getElementById('bookingPrintSection').innerHTML;
        const printWindow = window.open('', '_blank');
        
        printWindow.document.write(`
          <!DOCTYPE html>
          <html dir="rtl">
            <head>
              <title>إيصال حجز قاعة</title>
              <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&display=swap" rel="stylesheet">
              <style>
                @page {
                  size: A4;
                  margin: 1cm;
                }
                body {
                  font-family: 'Cairo', sans-serif;
                  direction: rtl;
                  margin: 0;
                  padding: 0;
                }
                @media print {
                  body {
                    print-color-adjust: exact;
                    -webkit-print-color-adjust: exact;
                  }
                }
              </style>
            </head>
            <body>
              ${printContent}
            </body>
          </html>
        `);
        
        printWindow.document.close();
        
        // Wait for images to load before printing
        printWindow.onload = function() {
          setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            printWindow.onafterprint = function() {
              printWindow.close();
            };
          }, 250);
        };
      } catch (error) {
        console.error('Error printing booking receipt:', error);
        this.$store.dispatch('showAlert', {
          message: 'حدث خطأ أثناء طباعة الإيصال',
          type: 'error'
        });
      }
    },
  },
  created() {
    this.initialize();
    console.log('Before fetchRooms');
    this.fetchRooms().then(response => {
      console.log('fetchRooms response:', response);
      console.log('Rooms after fetch:', this.roomsData);
    }).catch(error => {
      console.error('Error in fetchRooms:', error);
    });
    setTimeout(() => {
      console.log('Rooms state:', this.roomsData);
      console.log('Available rooms computed:', this.availableRooms);
    }, 1000);
  },
  watch: {
    'form.daily': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.form.time_from = '08:00';
          this.form.time_to = '16:00';
        } else {
          this.form.time_from = '16:00';
          this.form.time_to = '20:00';
        }
      }
    },
    'form.room_id': function() {
      this.handleRoomChange();
    },
    'form.time_to': function() {
      // Update price calculation when time_to changes
      this.calculateTotalPrice();
    },
    'form.discount': function(newVal) {
      // Existing discount watcher
      if (newVal === '') {
        this.form.discount = 0;
      }
    },
    'selectedDates': {
      handler(newDates) {
        if (newDates && Array.isArray(newDates)) {
          this.form.dates = newDates;
          this.calculateTotalPrice();
        }
      },
      deep: true
    },
    'form.number_of_people'() {
      this.calculateTotalPrice();
    },
    'form.coffee_breaks': {
      handler() {
        this.calculateTotalPrice();
      },
      deep: true
    },
    showAddDialog(val) {
      if (!val) {
        if (this.editedIndex === -1) {
          this.resetForm();
        }
      }
    },
    search() {
      this.handleSearch();
    },
    showDeletePaymentDialog(val) {
      if (!val) {
        this.paymentToDelete = null;
      }
    },
    showDeleteBookingDialog(val) {
      if (!val) {
        this.selectedBooking = null;
      }
    },
  }
}
</script>

<!-- Styles are now handled globally in src/assets/styles/global.css -->
